import React, { useContext, useEffect } from "react";
import { Link, useParams, useNavigate } from 'react-router-dom';
import logoSmall from './../../../public/Images/logo.png';
import './menu.css';
import { AuthContext } from '../Context/auth.jsx';
import ClimaFlutuante from "../../app/Components/ClimaFlutuante";
import { api } from "../../services/api.js";

function Menu(props) {
    const navigate = useNavigate();
    const { setLogado } = useContext(AuthContext);
    const { id } = useParams();
    const chapa = localStorage.getItem("chapa");
    const codLojaUser = Number(localStorage.getItem("loja") || 0);
    const exibeFilaAtendimento = codLojaUser > 50;

    const AcessoSap = localStorage.getItem("SAPADM");

    // Permissões lidas do localStorage
    const permiteVendas = localStorage.getItem("permiteVendas");
    const permitePonto = localStorage.getItem("permitePonto");
    const permiteCheckList = localStorage.getItem("CHECKLIST");
    const permiteCadastroCheckTI = localStorage.getItem("TICADCHECKLIST");
    const permiteVistoria = localStorage.getItem("vistoriaLoja");
    const eDiretor = localStorage.getItem("diretor");
    const permiteInventario = localStorage.getItem("INVENTARIO") === "S";

    const permiteRegional = localStorage.getItem("permiteRegional") || localStorage.getItem("diretor");
    const permiteFerias = localStorage.getItem("FERIAS");
    const isVistoria = permiteVistoria === "S" || permiteRegional === "S" || eDiretor === "S";
    const permiteDashBoardRH = localStorage.getItem("RHDASHBOARD");
    const isRestrito = chapa?.startsWith("90");
    const permiteControleEpi = localStorage.getItem("CONTROLEEPI") === "S";
    const permiteComunido = localStorage.getItem("permiteComunido") === "S";

    // Atendimento chamado
    const permissoesChamado = JSON.parse(localStorage.getItem("setorchamado") || "[]");
    const permiteAtendimento = permissoesChamado.length > 0;

    useEffect(() => {
        const handler = (e) => {
            if (!e.target.closest(".navbar")) {
                document.querySelectorAll(".dropdown-menu.show")
                    .forEach(el => el.classList.remove("show"));
                document.querySelectorAll(".dropdown-submenu.open-left")
                    .forEach(el => el.classList.remove("open-left"));
            }
        };

        document.addEventListener("click", handler);
        return () => document.removeEventListener("click", handler);
    }, []);

    function Logout() {
        setLogado(false);
        localStorage.clear();
    }

    const registrarAcessoFavorito = (item) => {
        try {
            const chapaUser = localStorage.getItem("chapa");
            const favKey = chapaUser ? `favoritos_${String(chapaUser).padStart(6, "0")}` : "favoritos_menus";

            const favsSalvos = localStorage.getItem(favKey);
            let listaAtual = favsSalvos ? JSON.parse(favsSalvos) : [];

            listaAtual = listaAtual.filter(f => f.to !== item.to);
            listaAtual.unshift(item);

            // PERMITE GUARDAR ATÉ 12 ITENS NO LOCALSTORAGE
            if (listaAtual.length > 12) {
                listaAtual = listaAtual.slice(0, 12);
            }

            localStorage.setItem(favKey, JSON.stringify(listaAtual));

            if (chapaUser) {
                api.post("/usuario/favoritos", {
                    chapa: chapaUser,
                    to: item.to,
                    text: item.text,
                    icon: item.icon || "fa-star"
                }).catch(() => { });
            }
        } catch (e) {
            console.error("Erro ao registrar favorito do menu:", e);
        }

        if (item.to.startsWith("http://") || item.to.startsWith("https://")) {
            window.open(item.to, "_blank");
        } else {
            navigate(item.to);
        }
    };

    const handleMenuPrincipalClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const currentMenu = e.currentTarget.parentElement;
        const menu = e.currentTarget.nextElementSibling;

        document.querySelectorAll(".navbar .nav-item.dropdown").forEach((el) => {
            if (el !== currentMenu) {
                el.querySelector(".dropdown-menu")?.classList.remove("show", "dropdown-menu-end");
                el.querySelectorAll(".dropdown-menu.show").forEach(sub => sub.classList.remove("show"));
                el.querySelectorAll(".dropdown-submenu").forEach(sub => sub.classList.remove("open-left"));
            }
        });

        if (menu) {
            const rect = e.currentTarget.getBoundingClientRect();
            const spaceRight = window.innerWidth - rect.left;

            if (spaceRight < 280) {
                menu.classList.add("dropdown-menu-end");
            } else {
                menu.classList.remove("dropdown-menu-end");
            }
            menu.classList.toggle("show");
        }
    };

    const handleSubmenuClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const currentItem = e.currentTarget.parentElement;
        const submenu = e.currentTarget.nextElementSibling;

        const parentMenu = currentItem.closest(".dropdown-menu");
        if (parentMenu) {
            parentMenu.querySelectorAll(".dropdown-submenu").forEach((el) => {
                if (el !== currentItem) {
                    el.classList.remove("open-left");
                    el.querySelector(".dropdown-menu")?.classList.remove("show");
                }
            });
        }

        const rect = e.currentTarget.getBoundingClientRect();
        const spaceRight = window.innerWidth - rect.right;

        if (spaceRight < 250) {
            currentItem.classList.add("open-left");
            if (submenu) submenu.classList.add("dropdown-menu-end");
        } else {
            currentItem.classList.remove("open-left");
            if (submenu) submenu.classList.remove("dropdown-menu-end");
        }

        submenu?.classList.toggle("show");
    };

    const isSapOrArbor = props.modulo === "SAP" || props.modulo === "ARBOR" || chapa === '900010' || chapa === '900001';
    const itsChecklist = permiteCheckList === "S";
    const isCheckCadastro = permiteCadastroCheckTI === "S";
    const itsAcessoRegional = chapa === '900010' || chapa === '900001';
    const permiteConciliacao = localStorage.getItem("CONCILIACARTAO") === "S";
    const permiteFichaFinanceira = localStorage.getItem("FICHAFINANCEIRA") === "S";
    const permiteFichaFinanceiraAP = localStorage.getItem("FICHAFINANCEIRAAPROV") === "S";

    return (
        <nav className="navbar fixed-top navbar-expand-md navbar-dark">
            <div className="container-fluid d-flex align-items-center justify-content-between">
                <a aria-current="page" href="/arbor/home">
                    <img className="logoarbor" src={logoSmall} alt="Rede Supermarket" title="Rede Supermarket" />
                </a>

                <div className="d-flex align-items-center gap-2 ms-auto me-2 d-md-none">
                    <Link
                        to="/arbor/home"
                        className="btn btn-sm btn-outline-light d-flex align-items-center justify-content-center p-2 rounded-3"
                        title="Ir para a Página Principal"
                        style={{ width: "38px", height: "38px" }}
                    >
                        <i className="fa fa-home fs-5"></i>
                    </Link>
                </div>

                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto">
                        {!isRestrito && props.modulo === "REST" && (
                            <>
                                <li className="nav-item">
                                    <span onClick={() => registrarAcessoFavorito({ to: "/restaurante/avaliacao/", text: "Avaliações", icon: "fa-star" })} className="nav-link cursor-pointer"><i className="fa fa-star" /> Avaliações</span>
                                </li>
                                <li className="nav-item">
                                    <span onClick={() => registrarAcessoFavorito({ to: "/restaurante/cardapio/", text: "Cardápio", icon: "fa-pencil" })} className="nav-link cursor-pointer"><i className="fa fa-pencil" /> Cardápio</span>
                                </li>
                                <li className="nav-item">
                                    <span onClick={() => registrarAcessoFavorito({ to: "/restaurante/dados/", text: "Dados Cadastrais", icon: "fa-address-card-o" })} className="nav-link cursor-pointer"><i className="fa fa-address-card-o" /> Dados Cadastrais</span>
                                </li>
                                <li className="nav-item">
                                    <span onClick={() => registrarAcessoFavorito({ to: "/restaurante/pedido/", text: "Pedidos", icon: "fa-cutlery" })} className="nav-link cursor-pointer"><i className="fa fa-cutlery" /> Pedidos</span>
                                </li>
                            </>
                        )}

                        {(!isRestrito && isSapOrArbor || itsAcessoRegional) && (
                            <li className="nav-item">
                                <Link to={"/arbor/home"} className="nav-link"><i className="fa fa-home" /> Principal</Link>
                            </li>
                        )}

                        {/* Menu Recursos Humanos */}
                        {!isRestrito && isSapOrArbor && (
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    role="button"
                                    onClick={handleMenuPrincipalClick}
                                >
                                    Recursos Humanos
                                </a>
                                <ul className="dropdown-menu">
                                    <li className="dropdown-submenu">
                                        <a href="#" className="dropdown-item dropdown-toggle" onClick={handleSubmenuClick}>
                                            <i className="fa fa-user-plus" /> AEFLOR
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/aeflor/assistencia", text: "AEFLOR Assistência", icon: "fa-hand-holding-usd" })} className="dropdown-item cursor-pointer"><i className="fa fa-hand-holding-usd" /> Assistência Financeira</span></li>
                                            <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/aeflor/convenio", text: "AEFLOR Convênio", icon: "fa-credit-card" })} className="dropdown-item cursor-pointer"><i className="fa fa-credit-card" /> Convênio</span></li>
                                            <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/aeflor", text: "AEFLOR Eventos", icon: "fa-calendar" })} className="dropdown-item cursor-pointer"><i className="fa fa-calendar" /> Eventos</span></li>
                                        </ul>
                                    </li>
                                    <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/rh/chamado", text: "Atendimento RH", icon: "fa-question-circle" })} className="dropdown-item cursor-pointer"><i className="fa fa-question-circle" /> Atendimento RH</span></li>
                                    <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/atestado", text: "Atestados", icon: "fa-user-md" })} className="dropdown-item cursor-pointer"><i className="fa fa-user-md" /> Atestados</span></li>
                                    <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/escala/", text: "Escala Trabalho", icon: "fa-calendar" })} className="dropdown-item cursor-pointer"><i className="fa fa-calendar" /> Escala de trabalho</span></li>
                                    <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/holerite/", text: "Holerites", icon: "fa-file-text-o" })} className="dropdown-item cursor-pointer"><i className="fa fa-file-text-o" /> Holerites</span></li>
                                    <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/dadosfunc/", text: "Meus Dados", icon: "fa-address-card" })} className="dropdown-item cursor-pointer"><i className="fa fa-address-card" /> Meus Dados</span></li>
                                    <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/notificacoes/", text: "Notificações", icon: "fa-bell" })} className="dropdown-item cursor-pointer"><i className="fa fa-bell" /> Notificações</span></li>
                                    <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/ponto/", text: "Ponto", icon: "fa-clock-o" })} className="dropdown-item cursor-pointer"><i className="fa fa-clock-o" /> Ponto</span></li>
                                    <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/restaurante", text: "Refeição", icon: "fa-cutlery" })} className="dropdown-item cursor-pointer"><i className="fa fa-cutlery" /> Refeição</span></li>
                                </ul>
                            </li>
                        )}

                        {/* Menu Ferramentas de Gestão */}
                        {isSapOrArbor && (
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    role="button"
                                    onClick={handleMenuPrincipalClick}
                                >
                                    Ferramentas
                                </a>
                                <ul className="dropdown-menu">

                                    {/* SUBMENU CONTABILIDADE / FINANCEIRO (ORDEM ALFABÉTICA) */}
                                    {(permiteFichaFinanceira || permiteConciliacao || permiteFichaFinanceiraAP) && (
                                        <li className="dropdown-submenu">
                                            <a href="#" className="dropdown-item dropdown-toggle" onClick={handleSubmenuClick}>
                                                <i className="fa fa-calculator" /> Contabilidade / Financeiro
                                            </a>

                                            <ul className="dropdown-menu">
                                                {permiteFichaFinanceiraAP && (
                                                    <li>
                                                        <span onClick={() => registrarAcessoFavorito({ to: "/arbor/fin/fichafinanceira/aprovacao", text: "Aprovação Ficha", icon: "fa-line-chart" })} className="dropdown-item cursor-pointer">
                                                            <i className="fa fa-line-chart" /> Aprovação Ficha
                                                        </span>
                                                    </li>
                                                )}

                                                {permiteConciliacao && (
                                                    <li>
                                                        <span onClick={() => registrarAcessoFavorito({ to: "/arbor/fin/conciliacao", text: "Conciliação Cartões", icon: "fa-credit-card" })} className="dropdown-item cursor-pointer">
                                                            <i className="fa fa-credit-card" /> Conciliação de Cartões
                                                        </span>
                                                    </li>
                                                )}

                                                {permiteFichaFinanceira && (
                                                    <li>
                                                        <span onClick={() => registrarAcessoFavorito({ to: "/arbor/fin/fichafinanceira", text: "Ficha Financeira", icon: "fa-university" })} className="dropdown-item cursor-pointer">
                                                            <i className="fa fa-university" /> Ficha Financeira
                                                        </span>
                                                    </li>
                                                )}
                                            </ul>
                                        </li>
                                    )}

                                    {/* SUBMENU OPERAÇÕES LOJA (ORDEM ALFABÉTICA) */}
                                    <li className="dropdown-submenu">
                                        <a href="#" className="dropdown-item dropdown-toggle" onClick={handleSubmenuClick}>
                                            <i className="fa fa-building" /> Operações Loja
                                        </a>

                                        <ul className="dropdown-menu">
                                            {permiteVendas === 'S' && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/produto/auditoria/", text: "Auditoria Produto", icon: "fa-cubes" })} className="dropdown-item cursor-pointer"><i className="fa fa-cubes me-2" /> Auditoria de Produto</span></li>}
                                            {isCheckCadastro && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/checklist/cadastro/", text: "Cadastro CheckList", icon: "fa-list" })} className="dropdown-item cursor-pointer"><i className="fa fa-list me-2" /> Cadastro Itens CheckList</span></li>}

                                            {/* SUBMENU CHAMADOS */}
                                            <li className="nav-item dropdown dropdown-submenu">
                                                <a
                                                    className="dropdown-item dropdown-toggle d-flex justify-content-between align-items-center"
                                                    href="#"
                                                    onClick={handleSubmenuClick}
                                                >
                                                    <span><i className="fa fa-ticket me-2" /> Chamados</span>
                                                </a>
                                                <ul className="dropdown-menu">
                                                    {permiteAtendimento && (
                                                        <li>
                                                            <span onClick={() => registrarAcessoFavorito({ to: "/arbor/chamado/atendimento", text: "Atendimento Chamados", icon: "fa-wrench" })} className="dropdown-item cursor-pointer">
                                                                <i className="fa fa-wrench me-2" /> Atendimento
                                                            </span>
                                                        </li>
                                                    )}
                                                    <li>
                                                        <span onClick={() => registrarAcessoFavorito({ to: "/arbor/chamado", text: "Meus Chamados", icon: "fa-user" })} className="dropdown-item cursor-pointer">
                                                            <i className="fa fa-user me-2" /> Meus Chamados
                                                        </span>
                                                    </li>
                                                </ul>
                                            </li>

                                            {itsChecklist && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/checklist/checklist/", text: "CheckList TI", icon: "fa-check-square-o" })} className="dropdown-item cursor-pointer"><i className="fa fa-check-square-o me-2" /> CheckList TI</span></li>}
                                            {permiteVendas === 'S' && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/equipamentos/", text: "Equipamentos", icon: "fa-shopping-cart" })} className="dropdown-item cursor-pointer"><i className="fa fa-shopping-cart me-2" /> Controle de Equipamentos</span></li>}
                                            {permiteRegional === 'S' && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/equipamentos/admin", text: "Equipamentos ADMIN", icon: "fa-cart-plus" })} className="dropdown-item cursor-pointer"><i className="fa fa-cart-plus me-2" /> Controle de Equipamentos ADMIN</span></li>}
                                            {itsChecklist && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/equipamentosti/", text: "Equipamentos TI", icon: "fa-desktop" })} className="dropdown-item cursor-pointer"><i className="fa fa-desktop me-2" /> Controle de Equipamentos TI</span></li>}
                                            <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/produto/", text: "Etiqueta", icon: "fa-barcode" })} className="dropdown-item cursor-pointer"><i className="fa fa-barcode me-2" /> Etiqueta</span></li>

                                            {permiteInventario && (
                                                <li>
                                                    <span onClick={() => registrarAcessoFavorito({ to: "/arbor/Loja/inventario", text: "Inventários", icon: "fa-cubes" })} className="dropdown-item cursor-pointer">
                                                        <i className="fa fa-cubes me-2" /> Inventários
                                                    </span>
                                                </li>
                                            )}

                                            {localStorage.getItem("PESQUISACOLETA") === 'S' && (
                                                <li>
                                                    <span onClick={() => registrarAcessoFavorito({ to: "/arbor/produto/pesquisa/coleta", text: "Pesquisa Coleta", icon: "fa-mobile" })} className="dropdown-item cursor-pointer">
                                                        <i className="fa fa-mobile me-2" /> Pesquisa Coleta
                                                    </span>
                                                </li>
                                            )}

                                            {(AcessoSap === "S" || eDiretor === "S" || permiteRegional === 'S') && (
                                                <li>
                                                    <span onClick={() => registrarAcessoFavorito({ to: "/arbor/produto/pesquisa", text: "Pesquisa Dashboard", icon: "fa-chart-bar" })} className="dropdown-item cursor-pointer">
                                                        <i className="fa fa-chart-bar me-2" /> Pesquisa Dashboard
                                                    </span>
                                                </li>
                                            )}

                                            {AcessoSap === "S" && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/sap/", text: "SAP Preços", icon: "fa-money" })} className="dropdown-item cursor-pointer"><i className="fa fa-money me-2" /> SAP - Solicitação de Preços</span></li>}
                                            <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/validade/", text: "Validade", icon: "fa-calendar" })} className="dropdown-item cursor-pointer"><i className="fa fa-calendar me-2" /> Validade</span></li>

                                            {isVistoria && (
                                                <li>
                                                    <span onClick={() => registrarAcessoFavorito({ to: "/arbor/loja/vistoria", text: "Vistoria Checklist", icon: "fa-pencil-square-o" })} className="dropdown-item cursor-pointer">
                                                        <i className="fa fa-pencil-square-o me-2" /> Vistoria - Checklist
                                                    </span>
                                                </li>
                                            )}
                                        </ul>
                                    </li>

                                    {/* SUBMENU PESSOAS (ORDEM ALFABÉTICA) */}
                                    <li className="dropdown-submenu">
                                        <a href="#" className="dropdown-item dropdown-toggle" onClick={handleSubmenuClick}>
                                            <i className="fa fa-users" /> Pessoas
                                        </a>

                                        <ul className="dropdown-menu">
                                            {permiteVendas === 'S' && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/usuario/consinco/", text: "Associar Operador PDV", icon: "fa-users" })} className="dropdown-item cursor-pointer"><i className="fa fa-users me-2" /> Associar Operador PDV</span></li>}
                                            {permitePonto === 'S' && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/escala/cadastro", text: "Cadastro de Escala", icon: "fa-calendar-plus-o" })} className="dropdown-item cursor-pointer"><i className="fa fa-calendar-plus-o me-2" /> Cadastro de Escala</span></li>}
                                            {permitePonto === 'S' && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/rh/clima/", text: "Clima e Humor", icon: "fa-smile-o" })} className="dropdown-item cursor-pointer"><i className="fa fa-smile-o me-2" /> Clima e Humor</span></li>}
                                            {(permiteRegional === 'S' || localStorage.getItem("RHDASHBOARD") === "S" || localStorage.getItem("diretor") === "S") && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/comunicado/", text: "Comunicação RH", icon: "fa-address-book" })} className="dropdown-item cursor-pointer"><i className="fa fa-address-book me-2" /> Comunicação RH</span></li>}
                                            {permiteVendas === 'S' && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/rh/acidente/", text: "Comunicado de Ocorrência", icon: "fa-user-md" })} className="dropdown-item cursor-pointer"><i className="fa fa-user-md me-2" /> Comunicado de Ocorrência</span></li>}

                                            {/* Rota para Consulta de Comunicados da Loja */}
                                            {permiteComunido && (
                                                <li>
                                                    <span onClick={() => registrarAcessoFavorito({ to: "/arbor/comunicado/consulta", text: "Consulta Comunicados Loja", icon: "fa-store" })} className="dropdown-item cursor-pointer">
                                                        <i className="fa fa-store me-2" /> Consulta Comunicados Loja
                                                    </span>
                                                </li>
                                            )}

                                            {permiteControleEpi && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/rh/controleepi", text: "Controle de EPI", icon: "fa-shield" })} className="dropdown-item cursor-pointer"><i className="fa fa-shield me-2" /> Controle de EPI</span></li>}
                                            {permiteDashBoardRH === "S" && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/rh/dashboard", text: "DashBoard RH", icon: "fa-bar-chart" })} className="dropdown-item cursor-pointer"><i className="fa fa-bar-chart me-2" /> DashBoard RH</span></li>}
                                            {(permiteRegional === 'S' || permiteFerias === 'S') && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/rh/ferias/", text: "Férias", icon: "fa-calendar" })} className="dropdown-item cursor-pointer"><i className="fa fa-calendar me-2" /> Férias</span></li>}
                                            {permitePonto === 'S' && <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/ponto/ocorrencias/", text: "Ocorrências Ponto", icon: "fa-clock-o" })} className="dropdown-item cursor-pointer"><i className="fa fa-clock-o me-2" /> Ocorrências de Ponto</span></li>}
                                        </ul>
                                    </li>

                                    {/* SUBMENU VENDAS (ORDEM ALFABÉTICA) */}
                                    {permiteVendas === 'S' && (
                                        <li className="dropdown-submenu">
                                            <a href="#" className="dropdown-item dropdown-toggle" onClick={handleSubmenuClick}>
                                                <i className="fa fa-line-chart" /> Vendas
                                            </a>
                                            <ul className="dropdown-menu">
                                                <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/vendas/comparativo/", text: "Vendas Comparativo Geral", icon: "fa-line-chart" })} className="dropdown-item cursor-pointer"><i className="fa fa-line-chart me-2" /> Vendas - Comparativo</span></li>
                                                <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/vendas/secao/", text: "Vendas Depto/Seção", icon: "fa-line-chart" })} className="dropdown-item cursor-pointer"><i className="fa fa-line-chart me-2" /> Vendas - Departamento/Seção</span></li>
                                                <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/vendas/secao/compara", text: "Vendas Depto/Seção Comparativo", icon: "fa-line-chart" })} className="dropdown-item cursor-pointer"><i className="fa fa-line-chart me-2" /> Vendas - Departamento/Seção Comparativo</span></li>
                                                <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/vendas/flash/", text: "Vendas Flash", icon: "fa-bolt" })} className="dropdown-item cursor-pointer"><i className="fa fa-bolt me-2" /> Vendas - Flash</span></li>
                                                <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/vendas/mes/", text: "Vendas Período", icon: "fa-line-chart" })} className="dropdown-item cursor-pointer"><i className="fa fa-line-chart me-2" /> Vendas - Período</span></li>
                                                <li><span onClick={() => registrarAcessoFavorito({ to: "/arbor/vendas/loja/", text: "Vendas Período Loja", icon: "fa-line-chart" })} className="dropdown-item cursor-pointer"><i className="fa fa-line-chart me-2" /> Vendas - Período Loja</span></li>
                                            </ul>
                                        </li>
                                    )}
                                </ul>
                            </li>
                        )}

                        {/* Menu Ouvidoria e outros (ORDEM ALFABÉTICA) */}
                        {(isSapOrArbor && !isRestrito || chapa === '900010') && (
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    role="button"
                                    onClick={handleMenuPrincipalClick}
                                >
                                    <i className="fa fa-comments" /> Ouvidoria e outros
                                </a>
                                <ul className="dropdown-menu">
                                    <li>
                                        <span onClick={() => registrarAcessoFavorito({ to: "/arbor/ouvidoria/", text: "Abrir Protocolo", icon: "fa-comments" })} className="dropdown-item cursor-pointer">
                                            <i className="fa fa-comments me-2" /> Abrir Protocolo
                                        </span>
                                    </li>
                                    {exibeFilaAtendimento && (
                                        <li>
                                            <span onClick={() => registrarAcessoFavorito({ to: "/arbor/atendimento/fila", text: "Fila de Atendimento", icon: "fa-users" })} className="dropdown-item cursor-pointer">
                                                <i className="fa fa-users me-2" /> Fila de Atendimento
                                            </span>
                                        </li>
                                    )}
                                </ul>
                            </li>
                        )}

                        {!isRestrito && props.modulo === "SAP" && (
                            <li className="nav-item">
                                <span onClick={() => registrarAcessoFavorito({ to: "/arbor/sap/horario/", text: "Horários", icon: "fa-clock-o" })} className="nav-link cursor-pointer"><i className="fa fa-clock-o" /> Horários</span>
                            </li>
                        )}

                        {props.modulo !== "NOVO1" && (
                            <li className="nav-item">
                                <a href="/" onClick={Logout} className="nav-link"><i className="fa fa-sign-out" /> Sair</a>
                            </li>
                        )}
                    </ul>
                </div>
            </div>

            <ClimaFlutuante />
        </nav>
    );
}

export default Menu;